import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";

const loginNumberKeys = [7, 8, 9, "AC", 4, 5, 6, "←", 1, 2, 3, null, 0];
const numberKeys = [
  7,
  8,
  9,
  4,
  5,
  6,
  1,
  2,
  3,
  0,
  "00",
  "AC",
  "←",
  null,
  "確定",
];

/**
 * 数字キーボードコンポーネント
 * @param {string} defaultValue 初期値
 * @param {Function} onChange キー押下時の処理
 * @param {Function} onSubmit 値確定の処理
 * @class NumberPad
 */
export default function NumberPad({
  defaultValue,
  onChange,
  onSubmit,
  isLogin = false,
}) {
  const [text, setText] = useState("");

  /**
   * 入力欄のテキストが変更されたら、その変更を反映する
   * @memberof NumberPad
   */
  useEffect(() => {
    onChange(text);
  }, [text, onChange]);
  /**
   * 初期値が指定されていれば、入力欄に反映する
   * @memberof NumberPad
   */
  useEffect(() => {
    if (defaultValue) setText(defaultValue);
  }, [defaultValue]);
  /**
   * キーボードが押下されたら、入力欄のテキストに追加する
   * @param {string} key 押下されたキーボードの値
   * @memberof NumberPad
   */
  const onClick = (key) => {
    if (`${key}`.match(/\d+/g) !== null) {
      setText(`${text}${key}`);
    } else if (key.match(/ac/gi)) {
      setText("");
    } else if (key === "確定") {
      onSubmit();
    } else {
      setText(text.slice(0, -1));
    }
  };

  return (
    <div
      className={`number-pad-container ${isMobile ? "mobile" : ""} ${isLogin ? "login" : ""}`}
      aria-label="数字キー"
    >
      {(isLogin ? loginNumberKeys : numberKeys).map((key) => (
        <>
          {key == null ? (
            <div className="empty" aria-hidden="true"></div>
          ) : (
            <button
              key={`number${key}`}
              onClick={() => onClick(key)}
              className={
                `${key}`.match(/^\d+$/g) === null
                  ? key === "確定"
                    ? "key-submit"
                    : "key-sub"
                  : key === 0
                    ? "key-zero"
                    : ""
              }
            >
              {key}
            </button>
          )}
        </>
      ))}
    </div>
  );
}
